import { createSystem, defaultConfig, defineConfig } from '@chakra-ui/react';

const config = defineConfig({
  theme: {
    tokens: {
      colors: {
        brand: {
          50: { value: '#e9f7ff' },
          100: { value: '#c9e9ff' },
          200: { value: '#a6dbff' },
          300: { value: '#77c6ff' },
          400: { value: '#49b0ff' },
          500: { value: '#1f96e6' },
          600: { value: '#0d74b4' },
          700: { value: '#075488' },
          800: { value: '#04355b' },
          900: { value: '#011c30' },
          950: { value: '#001020' },
        },
      },
      fonts: {
        heading: { value: '"Inter", "Segoe UI", system-ui, -apple-system, BlinkMacSystemFont, sans-serif' },
        body: { value: '"Inter", "Segoe UI", system-ui, -apple-system, BlinkMacSystemFont, sans-serif' },
      },
    },
    semanticTokens: {
      colors: {
        brand: {
          solid: { value: '{colors.brand.500}' },
          contrast: { value: '{colors.brand.100}' },
          fg: { value: '{colors.brand.700}' },
          muted: { value: '{colors.brand.100}' },
          subtle: { value: '{colors.brand.200}' },
          emphasized: { value: '{colors.brand.300}' },
          focusRing: { value: '{colors.brand.500}' },
        },
      },
    },
  },
  globalCss: {
    body: {
      bg: 'gray.50',
      color: 'gray.800',
    },
  },
});

export const system = createSystem(defaultConfig, config);

export default system;
